import store from "@/store";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import {
  ringCanvas,
  xCanvas,
  triangleCanvas,
  squareCanvas,
  rightAngleCanvas,
  circleCanvas,
  circleLineCanvas,
} from "@/rlMxModules/operate/customCanvas";
import * as THREE from "three";
import { MxFun } from "mxdraw";
const { Matrix4, Object3D, Vector3 } = THREE;
import { calculateArcAngle } from "@/rlMxModules/operate/GraphicDataCal.js";
import { McGePoint3d } from "mxcad";
var CSS2DObject = function (element) {
  Object3D.call(this);

  this.element = element;
  this.element.style.position = "absolute";

  this.addEventListener("removed", function () {
    this.traverse(function (object) {
      if (
        object.element instanceof Element &&
        object.element.parentNode !== null
      ) {
        object.element.parentNode.removeChild(object.element);
      }
    });
  });
};

CSS2DObject.prototype = Object.create(Object3D.prototype);
CSS2DObject.prototype.constructor = CSS2DObject;

//

var CSS2DRenderer = function () {
  var _this = this;

  var _width, _height;
  var _widthHalf, _heightHalf;

  var vector = new Vector3();
  var viewMatrix = new Matrix4();
  var viewProjectionMatrix = new Matrix4();

  var cache = {
    objects: new WeakMap(),
  };

  var domElement = document.createElement("div");
  domElement.style.overflow = "hidden";

  this.domElement = domElement;

  this.getSize = function () {
    return {
      width: _width,
      height: _height,
    };
  };

  this.setSize = function (width, height) {
    _width = width;
    _height = height;

    _widthHalf = _width / 2;
    _heightHalf = _height / 2;

    domElement.style.width = width + "px";
    domElement.style.height = height + "px";
  };

  var renderObject = function (object, scene, camera) {
    if (object instanceof CSS2DObject) {
      object.onBeforeRender(_this, scene, camera);

      vector.setFromMatrixPosition(object.matrixWorld);
      vector.applyMatrix4(viewProjectionMatrix);

      var element = object.element;
      var style =
        "translate(20%,11%) translate(" +
        (vector.x * _widthHalf + _widthHalf) +
        "px," +
        (-vector.y * _heightHalf + _heightHalf) +
        "px)";

      element.style.WebkitTransform = style;
      element.style.MozTransform = style;
      element.style.oTransform = style;
      element.style.transform = style;

      element.style.display =
        object.visible && vector.z >= -1 && vector.z <= 1 ? "" : "none";

      var objectData = {
        distanceToCameraSquared: getDistanceToSquared(camera, object),
      };

      cache.objects.set(object, objectData);

      if (element.parentNode !== domElement) {
        domElement.appendChild(element);
      }

      object.onAfterRender(_this, scene, camera);
    }

    for (var i = 0, l = object.children.length; i < l; i++) {
      renderObject(object.children[i], scene, camera);
    }
  };

  var getDistanceToSquared = (function () {
    var a = new Vector3();
    var b = new Vector3();

    return function (object1, object2) {
      a.setFromMatrixPosition(object1.matrixWorld);
      b.setFromMatrixPosition(object2.matrixWorld);

      return a.distanceToSquared(b);
    };
  })();

  var filterAndFlatten = function (scene) {
    var result = [];

    scene.traverse(function (object) {
      if (object instanceof CSS2DObject) result.push(object);
    });

    return result;
  };

  var zOrder = function (scene) {
    var sorted = filterAndFlatten(scene).sort(function (a, b) {
      var distanceA = cache.objects.get(a).distanceToCameraSquared;
      var distanceB = cache.objects.get(b).distanceToCameraSquared;

      return distanceA - distanceB;
    });

    var zMax = sorted.length;

    for (var i = 0, l = sorted.length; i < l; i++) {
      sorted[i].element.style.zIndex = zMax - i;
    }
  };

  this.render = function (scene, camera) {
    if (scene.autoUpdate === true) scene.updateMatrixWorld();
    if (camera.parent === null) camera.updateMatrixWorld();

    viewMatrix.copy(camera.matrixWorldInverse);
    viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, viewMatrix);

    renderObject(scene, scene, camera);
    zOrder(scene);
  };
};
// function drawCSS2DObject() {
//   const mxdraw = MxFun.getCurrentDraw();
//   const scene = mxdraw.getScene();
//   const canvas = document.createElement("canvas");
//   canvas.width = 100;
//   canvas.height = 100;
//   canvas.style.width = "100px";
//   canvas.style.height = "100px";

//   const ctx = canvas.getContext("2d");
//   if (ctx) {
//     ctx.beginPath();
//     ctx.arc(50, 50, 50, 0, Math.PI * 2); // 圆心在 (100, 100)，半径为 50
//     ctx.fillStyle = "red"; // 设置填充色为红色
//     ctx.fill(); // 填充圆形
//   }
//   // THREE
//   const obj = new CSS2DObject(canvas);
//   obj.position.copy(new THREE.Vector3(0, 0, 0));
//   const oCanvas = mxdraw.getCanvas();
//   const labelRenderer = new CSS2DRenderer();
//   labelRenderer.setSize(oCanvas.clientWidth, oCanvas.clientHeight);
//   labelRenderer.domElement.style.position = "absolute";
//   labelRenderer.domElement.style.top = "0";
//   labelRenderer.domElement.style.left = "0";

//   labelRenderer.domElement.style.pointerEvents = "none";
//   document.body.appendChild(labelRenderer.domElement);
//   mxdraw.addObject(obj);

//   const camera = mxdraw.getCamera();
//   const render = () => {
//     labelRenderer.render(scene, camera);
//     window.requestAnimationFrame(() => render());
//   };
//   render();
// }

let labelRenderer = null;
let canvas = null;
let objCSS2D = null;
//初始化捕捉数据
export const initStartSnapData = () => {
  const mxdraw = MxFun.getCurrentDraw();
  const scene = mxdraw.getScene();
  canvas = document.createElement("canvas");

  let canvasWidth = 200;
  let canvasHeight = 200;
  canvas.style.width = `${canvasWidth}px`;
  canvas.style.height = `${canvasHeight}px`;
  window.canvas = canvas;
  //文档坐标
  // const docPoint = MxFun.cadCoord2Doc(0, 0, 0);

  // let threePoint = MxFun.docCoord2World(0, 0, 0);
  //

  objCSS2D = new CSS2DObject(canvas); //three坐标
  objCSS2D.position.copy(new THREE.Vector3(0, 0, 0));
  // document.body.appendChild(canvas);
  const oCanvas = mxdraw.getCanvas();
  labelRenderer = new CSS2DRenderer(); //屏幕坐标
  labelRenderer.setSize(oCanvas.clientWidth, oCanvas.clientHeight);

  labelRenderer.domElement.style.position = "absolute";
  labelRenderer.domElement.style.top = "0";
  labelRenderer.domElement.style.left = "0";
  // labelRenderer.domElement.style.top = `${
  //   oCanvas.clientTop + canvasHeight / 2 + 22
  // }px`; //画布相较于屏幕的位置，非必要别动
  // labelRenderer.domElement.style.left = `${
  //   oCanvas.clientLeft + canvasWidth / 2 + 40
  // }px`; //画布相较于屏幕的位置，非必要别动

  // triangleCanvas(canvas, "red", 1);
  labelRenderer.domElement.style.pointerEvents = "none";
  document.body.appendChild(labelRenderer.domElement);
  // MxFun.getCurrentDraw().addObject(objCSS2D);
  mxdraw.addObject(objCSS2D);

  const camera = mxdraw.getCamera();
  const render = () => {
    labelRenderer.render(scene, camera);
    window.requestAnimationFrame(() => render());
  };
  render();
};

//画布大小变化时更新捕捉canvas位置
export const updateSnapData = () => {
  if (labelRenderer) {
    const mxdraw = MxFun.getCurrentDraw();
    const oCanvas = mxdraw.getCanvas();
    if (oCanvas) {
      labelRenderer.setSize(oCanvas.clientWidth, oCanvas.clientHeight);
    }
  }
};

/// 存储最近点
const tempClosestPoint = new THREE.Vector3();

// 获取最近的轴线
const getClosestAxis = (cadCoord, maxDist = 500) => {
  // 获取所有轴网
  const axisGroup = store.state.rlEntData.totalEntityData["rlAxis"];

  let lastMinDist = maxDist;
  let minDistAxis = null;
  let closestPt = null;

  // 遍历每一个轴网
  for (let i = 0; i < axisGroup.length; i++) {
    const item = axisGroup[i];
    const line = new THREE.Line3(
      new THREE.Vector3(...item.m_stJoint.m_pt),
      new THREE.Vector3(...item.m_edJoint.m_pt)
    );

    // 获取光标到该轴网的最近点
    line.closestPointToPoint(cadCoord, true, tempClosestPoint);

    // 克隆 tempClosestPoint 以避免在下一次迭代中被覆盖
    const closestPoint = tempClosestPoint.clone();
    const dist = closestPoint.distanceTo(cadCoord);

    // 记录最小距离的轴网
    if (dist < lastMinDist) {
      lastMinDist = dist;
      minDistAxis = item;
      closestPt = closestPoint;
    }
  }

  if (minDistAxis) {
    return { axisObj: minDistAxis, dist: lastMinDist, closestPt: closestPt };
  } else {
    //获取隔墙中线
    let nearestPartitionWall = getClosestPartitionWall(cadCoord, maxDist);
    if (nearestPartitionWall) {
      return nearestPartitionWall;
    }
    return null;
  }
};

// 计算最近的隔墙中线
const getClosestPartitionWall = (cadCoord, maxDist = 500) => {
  let lastMinDist = maxDist;
  let minDistGrid = null;
  let minDistPoint = null;

  //获取所有隔墙
  const PartitionWallGroup =
    store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];

  // 遍历每一个网格
  for (let i = 0; i < PartitionWallGroup.length; i++) {
    const objTmp = PartitionWallGroup[i];
    if (!objTmp.startPoint || !objTmp.endPoint) continue;
    if (objTmp) {
      const line = new THREE.Line3(
        new THREE.Vector3(
          objTmp.startPoint.x,
          objTmp.startPoint.y,
          objTmp.startPoint.z
        ),
        new THREE.Vector3(
          objTmp.endPoint.x,
          objTmp.endPoint.y,
          objTmp.endPoint.z
        )
      );

      // 获取光标到该网格的最近点
      line.closestPointToPoint(cadCoord, true, tempClosestPoint);

      // 克隆 tempClosestPoint 以避免在下一次迭代中被覆盖
      const closestPoint = tempClosestPoint.clone();
      const dist = closestPoint.distanceTo(cadCoord);

      // 记录最小距离的网格和最近点
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistGrid = objTmp;
        minDistPoint = closestPoint;
      }
    }
  }
  if (minDistGrid) {
    //造一个轴线数据
    let partitionWall = {
      m_gridIds: [
        {
          m_stJoint: {
            m_pt: [
              minDistGrid.startPoint.x,
              minDistGrid.startPoint.y,
              minDistGrid.startPoint.z,
            ],
          },
          m_edJoint: {
            m_pt: [
              minDistGrid.endPoint.x,
              minDistGrid.endPoint.y,
              minDistGrid.endPoint.z,
            ],
          },
          isPartitionWall: true,
        },
      ],
    };
    return {
      axisObj: partitionWall,
      dist: lastMinDist,
      closestPt: minDistPoint,
    };
  }
  return null;
};

// 计算最近的隔墙中线
const getClosestPartitionWall2 = (cadCoord, maxDist = 500) => {
  // if (closestAxis && closestAxis.m_gridIds.length) {
  let lastMinDist = maxDist;
  let minDistGrid = null;
  let minDistPoint = null;

  // 获取该轴线上的网格ID列表
  let gridIds = [];
  gridIds = store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
  // 遍历每一个网格
  for (let i = 0; i < gridIds.length; i++) {
    // const guid = gridIds[i];
    let objTmp = gridIds[i];
    //isPartitionWall为true时,数据是造的数据,不需要获取
    // if (!guid.isPartitionWall) {
    //   objTmp = getEntityData({
    //     Guid: guid,
    //     classTypeName: "rlGrid",
    //   });
    // } else objTmp = guid;

    if (objTmp && objTmp.m_gridData == null) {
      const line = new THREE.Line3(objTmp.startPoint, objTmp.endPoint);

      // 获取光标到该网格的最近点
      line.closestPointToPoint(cadCoord, true, tempClosestPoint);

      // 克隆 tempClosestPoint 以避免在下一次迭代中被覆盖
      const closestPoint = tempClosestPoint.clone();
      const dist = closestPoint.distanceTo(cadCoord);

      // 记录最小距离的网格和最近点
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistGrid = objTmp;
        minDistPoint = closestPoint;
      }
    }
  }
  if (minDistGrid) {
    return {
      gridObj: {
        m_stJoint: {
          m_pt: [
            minDistGrid.startPoint.x,
            minDistGrid.startPoint.y,
            minDistGrid.startPoint.z,
          ],
        },
        m_edJoint: {
          m_pt: [
            minDistGrid.endPoint.x,
            minDistGrid.endPoint.y,
            minDistGrid.endPoint.z,
          ],
        },
        classTypeName: "rlPartitionWallSeg",
      },
      closestPt: minDistPoint,
    };
  }
  // }
  return null;
};

// 计算最近的网格
const getClosestGrid = (cadCoord, maxDist = 500) => {
  //先隔墙
  let closestPartitionWall = getClosestPartitionWall2(cadCoord, maxDist);
  if (closestPartitionWall) {
    return closestPartitionWall;
  }
  if (closestPartitionWall) return closestPartitionWall;
  // if (closestAxis && closestAxis.m_gridIds.length) {
  let lastMinDist = maxDist;
  let minDistGrid = null;
  let minDistPoint = null;

  // 获取该轴线上的网格ID列表
  let gridIds = [];
  if (store.state.globalData.isSketch)
    gridIds = store.state.rlEntData.totalEntityData["rlGridC"];
  else gridIds = store.state.rlEntData.totalEntityData["rlGrid"];
  // 遍历每一个网格
  for (let i = 0; i < gridIds.length; i++) {
    // const guid = gridIds[i];
    let objTmp = gridIds[i];
    //isPartitionWall为true时,数据是造的数据,不需要获取
    // if (!guid.isPartitionWall) {
    //   objTmp = getEntityData({
    //     Guid: guid,
    //     classTypeName: "rlGrid",
    //   });
    // } else objTmp = guid;

    if (objTmp) {
      const line = new THREE.Line3(
        new THREE.Vector3(...objTmp.m_stJoint.m_pt),
        new THREE.Vector3(...objTmp.m_edJoint.m_pt)
      );

      // 获取光标到该网格的最近点
      line.closestPointToPoint(cadCoord, true, tempClosestPoint);

      // 克隆 tempClosestPoint 以避免在下一次迭代中被覆盖
      const closestPoint = tempClosestPoint.clone();
      const dist = closestPoint.distanceTo(cadCoord);

      // 记录最小距离的网格和最近点
      if (dist < lastMinDist) {
        lastMinDist = dist;
        minDistGrid = objTmp;
        minDistPoint = closestPoint;
      }
    }
  }
  if (minDistGrid) {
    return { gridObj: minDistGrid, closestPt: minDistPoint };
  }
  // else {
  //   let closestPartitionWall = getClosestPartitionWall2(cadCoord, maxDist);
  //   if (closestPartitionWall) {
  //     return closestPartitionWall;
  //   }
  // }
  // }
  return null;
};

//计算最近的节点
const getClosestJoint = (cadCoord, maxDist = 500) => {
  // 获取所有节点
  const jointGroup = store.state.rlEntData.totalEntityData["rlJoint"];

  let lastMinDist = maxDist;
  let minDistJoint = null;
  let closestPt = null;
  for (let i = 0; i < jointGroup.length; i++) {
    const item = jointGroup[i];
    if (!item) continue;
    let pt = new THREE.Vector3(...item.m_pt);

    const dist = pt.distanceTo(cadCoord);
    // 记录最小距离的轴网
    if (dist < lastMinDist) {
      lastMinDist = dist;
      minDistJoint = item;
      closestPt = pt;
    }
  }

  if (minDistJoint) {
    return { jointObj: minDistJoint, dist: lastMinDist, closestPt: closestPt };
  } else return null;
};

//计算获取网格上的构件端点
const getModelVertexs = () => {
  let rlEntData = store.state.rlEntData;
  const beamGroup = rlEntData.totalEntityData["rlBeamSeg"]; //获取所有梁数据
  const wallGroup = rlEntData.totalEntityData["rlWallSeg"]; //获取所有墙数据
  const colGroup = rlEntData.totalEntityData["rlColSeg"]; //获取所有柱数据

  let vertices = [];
  let lineSegs = [];
  if (beamGroup && beamGroup.length) {
    for (let i = 0; i < beamGroup.length; i++) {
      let obj = beamGroup[i];
      let polyObj = obj.mcDbId.getMcDbEntity();
      let number = polyObj.numVerts();
      for (let j = 0; j < number; j++) {
        let pt = polyObj.getPointAt(j).val;
        vertices.push(new THREE.Vector3(pt.x, pt.y, pt.z));
        if (j == number - 1) {
          lineSegs.push(new THREE.Line3(vertices[j], vertices[0]));
        } else if (i > 0) {
          lineSegs.push(new THREE.Line3(vertices[j - 1], vertices[j]));
        }
      }
    }
  }

  if (wallGroup && wallGroup.length) {
    for (let i = 0; i < wallGroup.length; i++) {
      let obj = wallGroup[i];
      let polyObj = obj.mcDbId.getMcDbEntity();
      let number = polyObj.numVerts();
      for (let j = 0; j < number; j++) {
        let pt = polyObj.getPointAt(j).val;
        vertices.push(new THREE.Vector3(pt.x, pt.y, pt.z));
        if (j == number - 1) {
          lineSegs.push(new THREE.Line3(vertices[j], vertices[0]));
        } else if (i > 0) {
          lineSegs.push(new THREE.Line3(vertices[j - 1], vertices[j]));
        }
      }
    }
  }

  if (colGroup && colGroup.length) {
    for (let i = 0; i < colGroup.length; i++) {
      let obj = colGroup[i];
      let polyObj = obj.mcDbId.getMcDbEntity();
      let number = polyObj.numVerts();
      for (let j = 0; j < number; j++) {
        let pt = polyObj.getPointAt(j).val;

        vertices.push(new THREE.Vector3(pt.x, pt.y, pt.z));
        if (j == number - 1) {
          lineSegs.push(new THREE.Line3(vertices[j], vertices[0]));
        } else if (i > 0) {
          lineSegs.push(new THREE.Line3(vertices[j - 1], vertices[j]));
        }
      }
    }
  }

  return { vertices: vertices, lineSegs: lineSegs };
};

//计算捕捉点
export const getSnapPtOnGrid = (
  cadCoord,
  lastPt = null,
  snapModel = false,
  maxDist = 500
) => {
  // 获取 canvas 上下文
  const context = canvas.getContext("2d");

  // 清除之前的绘制内容
  context.clearRect(0, 0, canvas.width, canvas.height);

  //获取构件上的顶点和线数据
  let modelSnapData = snapModel ? getModelVertexs() : null;

  let displayData = store.state.displayData;
  // currentCanvas.style.display = "none";
  // 获取最近的轴线
  // let closestAxis = getClosestAxis(cadCoord, maxDist);

  // if (!closestAxis) {
  //   //若找不到最近的轴线，计算节点和构件捕捉点
  //   if (displayData.endSnapPoint || displayData.cenSnapPoint) {
  //     //计算最近的节点
  //     let cloestJoint = getClosestJoint(cadCoord, maxDist);
  //     if (cloestJoint) {
  //       if (displayData.endSnapPoint) {
  //         drawSnapIcon(cloestJoint.closestPt, 1);
  //         return cloestJoint.closestPt;
  //       }
  //       //若捕捉点为圆心
  //       if (displayData.cenSnapPoint) {
  //         if (cloestJoint.jointObj.m_AxisIds.length > 0) {
  //           for (const item of cloestJoint.jointObj.m_AxisIds) {
  //             let objAxis = getEntityData({
  //               Guid: item,
  //               classTypeName: "rlAxis",
  //             });
  //             //弧形轴线的起点即为圆心
  //             if (
  //               objAxis &&
  //               objAxis.IsMainAxis < 0 &&
  //               objAxis.m_stJoint.Guid == cloestJoint.jointObj.Guid
  //             ) {
  //               drawSnapIcon(objAxis.m_stJoint.m_pt, 5);
  //               return objAxis.m_stJoint.m_pt;
  //             }
  //           }
  //         }
  //       }
  //     }

  //     if (
  //       modelSnapData &&
  //       modelSnapData.vertices &&
  //       modelSnapData.vertices.length > 0
  //     ) {
  //       for (let i = 0; i < modelSnapData.vertices.length; i++) {
  //         if (cadCoord.distanceTo(modelSnapData.vertices[i]) < maxDist) {
  //           drawSnapIcon(modelSnapData.vertices[i], 1);
  //           return modelSnapData.vertices[i];
  //         }
  //       }
  //     }
  //   }

  //   return cadCoord;
  // }

  //若无交点，获取轴线上的网格数据

  let zeroPoint = new THREE.Vector3(0, 0, 0); //原点,先判断是否在原点
  if (zeroPoint.distanceTo(cadCoord) < maxDist) {
    drawSnapIcon(zeroPoint, 1);
    return zeroPoint;
  }

  let closestGrid = getClosestGrid(cadCoord, maxDist);
  if (!closestGrid) {
    if (displayData.endSnapPoint) {
      if (
        modelSnapData &&
        modelSnapData.vertices &&
        modelSnapData.vertices.length > 0
      ) {
        for (let i = 0; i < modelSnapData.vertices.length; i++) {
          if (cadCoord.distanceTo(modelSnapData.vertices[i]) < maxDist) {
            drawSnapIcon(modelSnapData.vertices[i], 1);
            return modelSnapData.vertices[i];
          }
        }
      }
    }
    return cadCoord;
  }

  //最近网格的端点
  let closestGridSt = new THREE.Vector3(...closestGrid.gridObj.m_stJoint.m_pt);
  let closestGridEd = new THREE.Vector3(...closestGrid.gridObj.m_edJoint.m_pt);

  //若端点
  if (displayData.endSnapPoint) {
    if (store.state.cadModules.forceRlGridSnap) {
      // 计算当前鼠标位置与两端点的距离
      const distToStart = cadCoord.distanceTo(closestGridSt);
      const distToEnd = cadCoord.distanceTo(closestGridEd);

      // 返回距离更近的端点，无条件返回最近的点
      if (distToStart < distToEnd) {
        drawSnapIcon(closestGridSt, 1);
        return closestGridSt;
      } else {
        drawSnapIcon(closestGridEd, 1);
        return closestGridEd;
      }
    } else {
      // 原来的逻辑
      if (cadCoord.distanceTo(closestGridSt) < maxDist * 0.7) {
        drawSnapIcon(closestGridSt, 1);
        return closestGridSt;
      }
      if (cadCoord.distanceTo(closestGridEd) < maxDist * 0.7) {
        drawSnapIcon(closestGridEd, 1);
        return closestGridEd;
      }
    }
    if (
      modelSnapData &&
      modelSnapData.vertices &&
      modelSnapData.vertices.length > 0
    ) {
      for (let i = 0; i < modelSnapData.vertices.length; i++) {
        if (cadCoord.distanceTo(modelSnapData.vertices[i]) < maxDist) {
          drawSnapIcon(modelSnapData.vertices[i], 1);
          return modelSnapData.vertices[i];
        }
      }
    }
  }

  //若垂足
  if (displayData.perSnapPoint && lastPt) {
    let dir1 = new THREE.Vector3().subVectors(cadCoord, lastPt); // line1 的方向向量
    let dir2 = new THREE.Vector3().subVectors(closestGridSt, closestGridEd); // line2 的方向向量

    // 计算点积
    let dotProduct = dir1.dot(dir2);

    // 判断是否垂直
    if (Math.abs(dotProduct) < 0.00001) {
      // 如果垂直，计算垂足
      let p3ToP1 = new THREE.Vector3().subVectors(cadCoord, closestGridSt); // p3 到 p1 的向量
      let projectionLength = p3ToP1.dot(dir2) / dir2.lengthSq(); // 投影长度
      let footPoint = new THREE.Vector3()
        .copy(closestGridSt)
        .add(dir2.multiplyScalar(projectionLength)); // 垂足点

      drawSnapIcon(footPoint, 2);
      return footPoint;
    }

    // if (
    //   modelSnapData &&
    //   modelSnapData.lineSegs &&
    //   modelSnapData.lineSegs.length > 0
    // ) {
    //   for (let i = 0; i < modelSnapData.lineSegs.length; i++) {
    //     const line = modelSnapData.lineSegs[i];
    //     const vecDir = new THREE.Vector3();
    //     line.delta(vecDir);
    //     // 计算点积
    //     let dotProduct = dir1.dot(dir2);
    //     // 判断是否垂直
    //     if (Math.abs(dotProduct) < 1e-10) {
    //       // 如果垂直，计算垂足
    //       let p3ToP1 = new THREE.Vector3().subVectors(cadCoord, closestGridSt); // p3 到 p1 的向量
    //       let projectionLength = p3ToP1.dot(dir2) / dir2.lengthSq(); // 投影长度
    //       let footPoint = new THREE.Vector3()
    //         .copy(closestGridSt)
    //         .add(dir2.multiplyScalar(projectionLength)); // 垂足点

    //       drawSnapIcon(footPoint, 2);
    //       return footPoint;
    //     }
    //   }
    // }
  }

  //若中点
  if (displayData.midSnapPoint) {
    let midPoint = closestGridSt.clone().add(closestGridEd).divideScalar(2);
    if (cadCoord.distanceTo(midPoint) < maxDist * 0.5) {
      drawSnapIcon(midPoint, 3);
      return midPoint;
    }
  }

  //交点
  if (displayData.intSnapPoint) {
    if (cadCoord.distanceTo(closestGrid.closestPt) < maxDist * 0.2)
      drawSnapIcon(closestGrid.closestPt, 4);
    return closestGrid.closestPt;
  }

  //圆心
  if (
    displayData.cenSnapPoint &&
    closestGrid.gridObj.classTypeName != "rlPartitionWallSeg"
  ) {
    if (cadCoord.distanceTo(closestGrid.gridObj.centerPoint) < maxDist * 0.2)
      drawSnapIcon(closestGrid.gridObj.centerPoint, 5);
    return closestGrid.gridObj.centerPoint;
  }

  //切点
  if (
    displayData.tanSnapPoint &&
    lastPt &&
    closestGrid.gridObj.classTypeName != "rlPartitionWallSeg"
  ) {
    //判断当前点在弧形轴线上
    let objGrid = getEntityData({
      Guid: closestGrid.gridObj,
      classTypeName: "rlAxis",
    });
    if (objGrid && objGrid.m_centerJoint) {
      //判断当前点是否在弧形轴线上
      //获取弧形轴线
      let startAngle = objGrid.mcDbId.getMcDbEntity().startAngle;
      let endAngle = objGrid.mcDbId.getMcDbEntity().endAngle;
      let angle = calculateArcAngle(objGrid.m_stJoint.m_pt, cadCoord);
      if (angle >= startAngle && angle <= endAngle) {
        //判断当前直线与圆心和交点的连线是否垂直
        let dir1 = new THREE.Vector3().subVectors(
          cadCoord,
          new THREE.Vector3(...objGrid.m_stJoint.m_pt)
        );
        let dir2 = new THREE.Vector3().subVectors(cadCoord, lastPt);
        let dotProduct = dir1.dot(dir2);
        if (Math.abs(dotProduct) < 1e-10) {
          drawSnapIcon(cadCoord, 6);
          return cadCoord;
        }
      }
    }

    if (cadCoord.distanceTo(closestGrid.gridObj.tangentPoint) < maxDist * 0.2)
      drawSnapIcon(closestGrid.gridObj.tangentPoint, 6);
    return closestGrid.gridObj.tangentPoint;
  }

  return cadCoord;
};

export const removeCurrentCanvas2DObject = () => {
  if (currentCanvas) {
    currentCanvas.style.display = "none";
  }
};

export const drawSnapIcon = (intersectionPoint, snapType) => {
  let color = "#FF0000";
  let lineWidth = 1;
  // let threePoint = MxFun.doccoord2World(
  //   intersectionPoint.x,
  //   intersectionPoint.y,
  //   intersectionPoint.z
  // );
  //
  //设定位置
  objCSS2D.position.copy(intersectionPoint);
  //绘制捕捉标识
  if (snapType == 1)
    //端点
    squareCanvas(canvas, color, lineWidth);
  else if (snapType == 2)
    //垂足
    rightAngleCanvas(canvas, color, lineWidth);
  else if (snapType == 3)
    //中点
    triangleCanvas(canvas, color, lineWidth);
  else if (snapType == 4)
    //交点
    xCanvas(canvas, color, lineWidth);
  else if (snapType == 5)
    //圆心
    circleCanvas(canvas, color, lineWidth);
  else if (snapType == 6)
    //切点
    circleLineCanvas(canvas, color, lineWidth);
};

// this.dxfViewMove = (event) => {
//   if (this.isinsert || this.onDxfMove) {
//     const { width, height, left, top } = this.getDxfViewRect(dxf_compare_view);
//     const mouse = new THREE.Vector2();
//     mouse.x = ((event.clientX - left) / width) * 2 - 1;
//     mouse.y = -((event.clientY - top) / height) * 2 + 1;

//     raycaster.setFromCamera(mouse, dxfViewer.camera);

//     let intersects = raycaster.intersectObjects(dxfViewer.scene.children, true);
//     const tolerance = dxfViewer.getPixelSizeInWorldCoord() * 3;
//     oSnapHelper.setSnapTolerance(tolerance);
//     if (this.isOneClick) {
//       oldPoint2 = oSnapHelper.handleSnap(intersects, false);
//     } else {
//       oldPoint = oSnapHelper.handleSnap(intersects, false);
//     }

//     const pointsAndLines =
//       intersects.length != 0
//         ? getIntersectionPointsAndLines(
//             hitResult,
//             intersects,
//             false,
//             dxfViewer.camera.zoom
//           )
//         : [];

//     let intersectionPoint;
//     if (pointsAndLines && pointsAndLines.length != 0) {
//       for (let i = 0; i < pointsAndLines.length; i++) {
//         for (let j = i + 1; j < pointsAndLines.length; j++) {
//           const line1 = pointsAndLines[i];
//           const line2 = pointsAndLines[j];
//           intersectionPoint = lineIntersectionPoint(line1, line2);
//         }
//       }
//     }

//     // 移除当前场景中的canvas2dObject
//     removeCurrentCanvas2DObject();

//     const { canvas, canvas2dObject } = createCanvas2DObject();
//     currentCanvas2DObject = canvas2dObject;

//     dxfViewer.enableRender();

//     function set2D(isSpecial, point, intersectionPoint) {
//       if (isSpecial) {
//         if (intersectionPoint) {
//           canvas2dObject.position.copy(intersectionPoint);
//           oldPoint = intersectionPoint;
//         }
//       } else {
//         canvas2dObject.position.copy(point);
//         oldPoint = point;
//       }
//       canvas2dObject.updateMatrixWorld();
//     }
//     const epsilon = 120; // 用于比较浮点数相等的阈值
//     let shapeDrawn = false; // 添加一个变量来跟踪是否已经绘制了一个图形
//     // 遍历交集数组
//     for (const intersect of intersects) {
//       // 如果交集对象类型不是 Mesh
//       if (intersect.object.type !== "Mesh") {
//         const currentIntersect = intersect;
//         // 如果交点存在且交点的 x 坐标不是 NaN
//         if (!shapeDrawn && intersectionPoint && !isNaN(intersectionPoint.x)) {
//           set2D(true, currentIntersect.point, intersectionPoint);
//           // 在画布上绘制矩形
//           drawRepeated(squareCanvas, canvas, "#FF0000", 0.2);
//           shapeDrawn = true;
//         }
//         for (const pl of pointsAndLines) {
//           const start = pl.start;
//           const end = pl.end;
//           // 检查端点是否与当前相交点相等
//           const startPointEqual =
//             almostEqual(start.x, currentIntersect.point.x, epsilon) &&
//             almostEqual(start.y, currentIntersect.point.y, epsilon);
//           const endPointEqual =
//             almostEqual(end.x, currentIntersect.point.x, epsilon) &&
//             almostEqual(end.y, currentIntersect.point.y, epsilon);
//           if (!shapeDrawn && (startPointEqual || endPointEqual)) {
//             set2D(false, startPointEqual ? start : end, intersectionPoint);
//             drawRepeated(xCanvas, canvas, "#FF0000", 0.2);
//             shapeDrawn = true;
//             break;
//           }
//           // 如果没有找到端点，检查中点
//           // 计算中点
//           const midpoint = new THREE.Vector3();
//           midpoint.x = (start.x + end.x) / 2;
//           midpoint.y = (start.y + end.y) / 2;
//           // 检查中点是否与当前相交点相等
//           const midPointEqual =
//             almostEqual(midpoint.x, currentIntersect.point.x, epsilon) &&
//             almostEqual(midpoint.y, currentIntersect.point.y, epsilon);
//           if (!shapeDrawn && midPointEqual) {
//             set2D(false, midpoint, intersectionPoint);
//             drawRepeated(triangleCanvas, canvas, "#FF0000", 0.2); // 绘制中点时使用不同的颜色
//             shapeDrawn = true;
//             break;
//           }
//         }
//         // 如果既不是交点也不是端点也不是中点，处理普通点
//         if (!shapeDrawn) {
//           set2D(false, currentIntersect.point, intersectionPoint);
//           // 在画布上绘制圆环
//           drawRepeated(ringCanvas, canvas, "#FF0000", 0.2);
//           shapeDrawn = true;
//         }
//       } else {
//         // 移除当前场景中的 canvas2dObject
//         removeCurrentCanvas2DObject();
//       }
//     }
//     if (!canvas2dObject.parent) {
//       dxfViewer.scene.add(canvas2dObject);
//     }
//     // 绘制重复图形的辅助函数
//     function drawRepeated(drawFunction, ...args) {
//       // 根据给定次数重复绘制图形
//       // 清除图形
//       if (!canvas2dObject.parent) {
//         dxfViewer.scene.remove(canvas2dObject);
//       }
//       drawFunction(...args);
//     }
//   }
// };
